const stats = [
  { value: "iOS", label: "Platform Focus" },
  { value: "100%", label: "User Privacy" },
];

export default function AboutSection() {
  return (
    <section id="about" className="py-32 bg-[#F7F5F2]">
      <div className="max-w-7xl mx-auto px-8 md:px-16">
        {/* Section header */}
        <div className="flex flex-col items-center text-center mb-20">
          <span className="text-xs tracking-[0.35em] uppercase text-amber-700 font-semibold mb-4">
            Who We Are
          </span>
          <h2 className="text-5xl md:text-6xl font-black text-gray-900 leading-tight mb-6">
            About<br />
            <span className="text-amber-700">MANI D.O.O</span>
          </h2>
          <div className="w-16 h-0.5 bg-amber-600" />
        </div>

        {/* Two-column layout */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-20 items-center">
          {/* Left: image */}
          <div className="relative">
            <div className="w-full h-[520px] rounded-3xl overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/773fb905f2444a691232b3bc618be4a0.jpg"
                alt="MANI D.O.O team working on iOS applications"
                className="w-full h-full object-cover object-top"
              />
            </div>
            {/* Accent card */}
            <div className="absolute -bottom-8 -right-8 bg-amber-700 text-white rounded-2xl p-8 w-56">
              <p className="text-4xl font-black mb-1">iOS</p>
              <p className="text-sm font-light tracking-wide opacity-90">Platform Specialists</p>
            </div>
          </div>

          {/* Right: content */}
          <div>
            <p className="text-lg text-gray-600 leading-relaxed mb-8">
              <strong className="text-gray-900">MANI D.O.O</strong> is a dedicated team of experts focused exclusively on the iOS platform. We combine deep technical knowledge with a passion for elegant, functional design to deliver applications that truly make a difference in people&apos;s daily lives.
            </p>
            <p className="text-lg text-gray-600 leading-relaxed mb-12">
              Our products are built with a singular mission: to protect users and simplify their digital experience. Every feature we build is thoughtfully crafted to meet the highest standards of performance, privacy, and usability on Apple devices.
            </p>

            {/* Stats */}
            <div className="grid grid-cols-2 gap-6">
              {stats.map((stat) => (
                <div key={stat.label} className="border border-gray-200 rounded-2xl p-6 bg-white text-center">
                  <p className="text-3xl font-black text-amber-700 mb-1">{stat.value}</p>
                  <p className="text-xs text-gray-500 tracking-wide uppercase">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Values row */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-24">
          {[
            {
              icon: "ri-shield-check-line",
              title: "Security First",
              desc: "Every product is engineered with robust protection mechanisms to safeguard user data and device integrity.",
            },
            {
              icon: "ri-smartphone-line",
              title: "iOS Native",
              desc: "Purpose-built for the iOS ecosystem, ensuring seamless integration and peak performance on Apple devices.",
            },
            {
              icon: "ri-user-heart-line",
              title: "User-Centric",
              desc: "Clean, intuitive interfaces designed to deliver an exceptional user experience from first launch.",
            },
          ].map((item) => (
            <div key={item.title} className="bg-white rounded-3xl p-8 border border-gray-100">
              <div className="w-12 h-12 flex items-center justify-center bg-amber-50 rounded-2xl mb-6">
                <i className={`${item.icon} text-2xl text-amber-700`} />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">{item.title}</h3>
              <p className="text-sm text-gray-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
